import React, { useState, useRef, useEffect } from "react";
import { get } from "lodash";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp, faAngleDown } from "@fortawesome/pro-light-svg-icons";
import { getPathWithParam } from "../../utils";
import { Accordion, Card } from "react-bootstrap";
import "../../styles/components/PlanlevelCommunication.scss";
import tenantConfig from "../../mocks/tenantOne.json";
import authorization from "../../mocks/menuPermissions.json";
import authService from "../api-authorization/AuthorizeService";

const ManageCommunicationMenu = ({
  menuList = [],
  selectedMenu,
  flow,
  eligibilityId,
}) => {
  const [roleName, setRoleName] = useState("VOU");
  const location = useLocation();
  const [selectedItemId, setSelectedItemId] = useState("/communication/plan-level-communication");
  useEffect(() => {
    getRole();
  }, []);
  useEffect(() => {
    setSelectedItemId(location.pathname);
  }, [location.pathname]);

  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  const [select, setSelect] = useState(true);
  const [activeKey, setActiveKey] = useState("0");
  const [selectLi, setSelectLi] = useState(0);
  const closeAccordton = useRef(null);
  return (
    <ul className="manage-report-menu" style={{marginLeft:"-37px", marginBottom : "0px"}} >
      {menuList.map((item, i) => {
        const childRoutes = get(item, "childRoutes", []);
        const subNav = get(item, "subNav", []);
        const toggleAccordion = () => {
          if (select) {
            closeAccordton.current.click();
            setSelectLi(null);
          }
        };
        let className =
          selectedMenu.indexOf(item.path) !== -1 ||
          childRoutes.filter((route) => {
            return selectedMenu.indexOf(route) !== -1;
          }).length
            ? "selected"
            : "";
        if (subNav.length > 0)
          return (
            <Accordion defaultActiveKey={activeKey}>
              <Accordion.Toggle
                as={Card.Header}
                eventKey="0"
                onClick={() => {
                  setSelect(!select);
                  setActiveKey("0");
                }}
                ref={closeAccordton}
              >
                <FontAwesomeIcon
                  icon={select ? faAngleUp : faAngleDown}
                  size="1x"
                />
                <span className={selectLi != null ? "itemBold" : ""}>
                  {"  " + item.label}
                </span>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="0">
                <ul style={{marginLeft:"-50px"}}>
                  {subNav.map((data, index) => {
                    return (
                      <li key={index}>
                        <Link
                          to={getPathWithParam({
                            path: data.path,
                          })}
                          onClick={() => setSelectedItemId(data.path)}
                          style ={{color: selectedItemId === data.path ? "#0ab89a" : "#212529"}}
                        >
                          <span
                            style={{
                              "white-space": "pre-wrap",
                              "overflow-wrap": "break-word",
                              marginLeft:"42px"
                            }}
                            onClick={() => setSelectLi(index)}
                            className={selectLi === index ? "itemBold" : ""}
                          >
                            {data.label}
                          </span>
                        </Link>
                        <span className="open-rounded-corner-top" />
                        <span className="open-rounded-corner-bottom" />
                      </li>
                    );
                  })}
                </ul>
              </Accordion.Collapse>
            </Accordion>
          );
        else
          return (
            tenantConfig.communicationSubMenu.includes(item.id) &&
            authorization[roleName].communicationSubMenu[item.id] && (
              <>
              <Accordion>
              <Accordion.Toggle
                as={Card.Header}
                eventKey="0"
                onClick={() => {
                  setActiveKey("0");
                  setSelectedItemId(item.path);
                }}
                ref={closeAccordton}
              >
                  <Link
                    to={getPathWithParam({
                      path: item.path,
                    })}
                    onClick={() => toggleAccordion()}
                    style ={{color: selectedItemId === item.path ? "#0ab89a" : "#212529"}}
                  >
                    <span className={selectLi != null ? "itemBold" : ""}>
                      {" " + item.label}
                    </span>
                  </Link>
              </Accordion.Toggle>
              </Accordion>
              </>
            )
          );
      })}
    </ul>
  );
};

export default ManageCommunicationMenu;
